import Vue from 'vue'
import Vuetify from 'vuetify/lib'

const colors = {
  gris: '#B5B5BA',
  rojo: '#BD614D',
  mostaza: '#E6C57D',
  celeste: '#81B5DE',
}

Vue.use(Vuetify, {
  theme: {
    primary: colors.celeste,
    info: colors.celeste,
    red: colors.rojo,
    error: colors.rojo,
    warning: colors.mostaza,
    orange: colors.mostaza,
    //secondary: '#424242',
    //accent: '#82B1FF',
    //error: colors.rojo,
    success: '#4CAF50',
    //warning: colors.mostaza,
    //orange: colors.mostaza,
  },
})
